import { useAtomValue } from 'jotai'

import { currentWorkSpaceIdAtom, workSpaceAtom, workSpaceListAtom } from '@/atoms/workSpace/state'

export const useCurrentSpaceID = () => {
    return useAtomValue(currentWorkSpaceIdAtom)
}

export const useWorkSpaceList = () => {
    return useAtomValue(workSpaceListAtom)
}

export const useWorkSpace = () => {
    return useAtomValue(workSpaceAtom)
}
